import { useEffect, useRef, useState } from "react";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import moment from "moment";
import { useDebounce } from "../../../customHooks/useDebounceHook";
import useGetHook from "../../../customHooks/useGetHook";
import APIS from "../../../constant/EndPoint";
import usePostHook from "../../../customHooks/usePostHook";
import Spinner from "../../Reusable/Spinner";

const CargoDeliveryChargeTable = (props: any) => {
  const {
    localServiceBranch,
    localServiceType,
    localProductType = [],
    merchantId,
    id,
  } = props;

  const Product_type = localProductType
    ?.map((item: any) => item?.value)
    ?.join(",");
  const [searchParams, setSearchParms] = useSearchParams({
    searchQuery: "",
  });
  const searchQuery = searchParams.get("searchQuery");
  const debounceSearch = useDebounce(searchQuery);

  const {
    data: deliveryChargeData,
    isLoading: DeliveryChargeLoading,
    isRefetching,
  } = useGetHook({
    queryKey: [
      "delivery-charge",
      `delivery-charge-${localServiceBranch}-${localServiceType}-${merchantId}-${Product_type}-${debounceSearch}-${id}`,
    ],
    url: APIS.CARGO_DELIVERY_CHARGE,
    params: {
      branch: localServiceBranch,
      localServiceType: localServiceType,
      product_type: localProductType
        ?.map((item: any) => item?.value)
        ?.join(","),
      merchant: merchantId,
      delivery_charge_template: id,
      search: debounceSearch,
    },
  });

  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: [
      "delivery",
      `delivery-${localServiceBranch}-${localServiceType}-${merchantId}-${Product_type}-${debounceSearch}-${id}`,
    ],
    navigateURL: ``,
  });

  const handleDeliveryChargeChange = async (
    destination_city: string,
    product_type: string,
    amount: string,
    weightRange: any
  ) => {
    const url = `${APIS.DELIVERY_CHARGE}`;
    let formData = {
      delivery_charge_template: id,
      pickup_branch: localServiceBranch,
      destination_city: destination_city,
      merchant: merchantId,
      service_type: localServiceType,
      product_type: product_type,
      amount: amount,
      weight_range: weightRange,
    };

    try {
      const res = await mutateAsync({ url, formData });
    } catch (err) {
      console.log(err);
    }
  };

  const [rerender, setRerender] = useState(true);

  const handleSearch = (value) => {
    searchParams.set("searchQuery", value);
    setSearchParms(searchParams);
  };

  useEffect(() => {
    setRerender(!rerender);
  }, [deliveryChargeData]);

  const fileInputRef = useRef<HTMLInputElement>(null);

  return (
    <div className={tw`w-full overflow-hidden min-h-10`}>
      {DeliveryChargeLoading || isRefetching ? (
        <Spinner />
      ) : (
        <div className={tw`w-full`}>
          {deliveryChargeData?.header?.map((headerItem, hIndex) => {
            const groupCount = Math.floor(
              deliveryChargeData.body.length / deliveryChargeData.header.length
            );
            const bodyStart = hIndex * groupCount;
            const bodyEnd = bodyStart + groupCount;

            const productBody = deliveryChargeData.body.slice(
              bodyStart,
              bodyEnd
            );
            console.log(groupCount);
            return (
              <div
                key={headerItem.id}
                className={tw`border mb-4 p-2 rounded-md bg-white shadow`}
              >
                <div className={tw``}>
                  <table className={tw`w-full border`}>
                    <thead>
                      <tr>
                        <th
                          className={tw`border px-2 text-left font-semibold`}
                          colSpan={productBody.length + 1}
                        >
                          {headerItem.name}
                        </th>
                      </tr>

                      <tr>
                        <th className={tw`border px-2 whitespace-nowrap`}>
                          Weight (Kg)
                        </th>

                        {productBody.map((group) => (
                          <th
                            key={group.group_id}
                            className={tw`text-center border relative group px-2`}
                          >
                            {group.name}

                            {/* GROUP HOVER DETAILS */}
                            <div
                              className={tw`
              absolute left-1/2 top-full mt-1 w-40 -translate-x-1/2
              rounded-md bg-white shadow-lg border p-2 text-sm z-10
              opacity-0 scale-95 pointer-events-none
              group-hover:opacity-100 group-hover:scale-100 group-hover:pointer-events-auto
              transition-all duration-200
            `}
                            >
                              {group?.countries?.length > 0 ? (
                                <ul className={tw`text-left`}>
                                  {group.countries.map((c, i) => (
                                    <li key={i}>{c}</li>
                                  ))}
                                </ul>
                              ) : (
                                <p className={tw`text-gray-400`}>
                                  No countries
                                </p>
                              )}
                            </div>
                          </th>
                        ))}
                      </tr>
                    </thead>

                    <tbody>
                      {deliveryChargeData?.non_flat_weight_ranges
                        ?.filter(([start, end]) =>
                          headerItem.name === "Document" ? end <= 1 : true
                        )
                        .map(([start, end], rowIndex) => (
                          <tr key={rowIndex} className={tw`border`}>
                            <td className={tw`border px-2 whitespace-nowrap`}>
                              {start} – {end}
                            </td>

                            {productBody.map((group) => (
                              <td
                                key={group.group_id}
                                className={tw`border px-2`}
                              >
                                <input
                                  type="text"
                                  className={tw`bg-transparent w-full text-center`}
                                  defaultValue={group?.rate?.[rowIndex] ?? ""}
                                  disabled={true}
                                />
                              </td>
                            ))}
                          </tr>
                        ))}

                      {headerItem.name !== "Document" && (
                        <>
                          <tr>
                            <td
                              className={tw`border font-semibold`}
                              colSpan={productBody.length + 1}
                            >
                              Flat rate per kg
                            </td>
                          </tr>

                          {deliveryChargeData?.flat_weight_ranges?.map(
                            ([start, end], idx) => {
                              const isLast =
                                idx ===
                                deliveryChargeData.flat_weight_ranges.length -
                                  1;
                              const overallIndex =
                                idx +
                                deliveryChargeData.non_flat_weight_ranges
                                  .length;

                              return (
                                <tr key={overallIndex} className={tw`border`}>
                                  <td
                                    className={tw`border px-2 whitespace-nowrap`}
                                  >
                                    {isLast
                                      ? `${start} and above`
                                      : `${start} – ${end}`}
                                  </td>

                                  {productBody.map((group) => (
                                    <td
                                      key={group.group_id}
                                      className={tw`border px-2`}
                                    >
                                      <input
                                        type="text"
                                        className={tw`bg-transparent w-full text-center`}
                                        defaultValue={
                                          group?.rate?.[overallIndex] ?? ""
                                        }
                                        onBlur={(e) =>
                                          handleDeliveryChargeChange(
                                            group.group_id,
                                            headerItem?.id,
                                            e.target.value,
                                            [start, end]
                                          )
                                        }
                                      />
                                    </td>
                                  ))}
                                </tr>
                              );
                            }
                          )}
                        </>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default CargoDeliveryChargeTable;
